module.exports = __webpack_public_path__ + "img/caroline-hurtubise.0558b11e.png";